import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M29.29,15.67,22.9,4.61a.64.64,0,0,0-.56-.32H11.57v1.3H22L28,16,22,26.41H10L3.75,15.67l-1.13.66L9,27.39a.64.64,0,0,0,.56.32H22.34a.64.64,0,0,0,.56-.32l6.39-11.06A.65.65,0,0,0,29.29,15.67Z' }),
  React.createElement('path', { d: 'M11.36,16l.32,1.26,3.65-.89a1.39,1.39,0,0,0,.85-.63,1.36,1.36,0,0,0,.16-1.06L15.44,11l-1.26.31.7,2.83-9.54-6-.69,1.1,9.58,6Z' })
));